__webpack_require__.p = "/sanket-s-portfolio/";